import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, retry } from 'rxjs';
import { Role } from '../models/role.model';
import { environment } from '../../environments/environment';

export interface CreateRoleDto {
  title: string;
  description?: string;
  isActive?: boolean;
  serviceGroupId?: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  private apiUrl = `${environment.apiUrl}/Role`;

  constructor(private http: HttpClient) { }

  getAllRoles(): Observable<Role[]> {
    return this.http.get<Role[]>(this.apiUrl).pipe(retry(2));
  }

  addRole(role: Role): Observable<Role> {
    const createDto: CreateRoleDto = {
      title: role.title,
      description: role.description,
      isActive: role.isActive !== undefined ? role.isActive : true,
      serviceGroupId: role.serviceGroupId || null
    };
    return this.http.post<Role>(this.apiUrl, createDto);
  }

  updateRole(id: string, role: Role): Observable<Role> {
    return this.http.put<Role>(`${this.apiUrl}/${id}`, role);
  }
}


